<template>
  <div class='flex justify-between mb-db items-center mb-100 mb-mb-60 pl-50 pr-10 tl-pl-0 tl-pr-0'>
    <div class='mb-wp-100 mb-mb-60'>
      <img class='img-cover' :src="`https://s3-cdn.designerjourneys.com/static/images/aboutus/who-we-are.png`" alt='banner'>
    </div>
    <div class='pl-100 mb-pl-0 mb-wp-100'>
      <div class='maxw-410 mb-maxwp-100'>
        <h2 class='fs-36 mb-fs-28 fw-900 mb-30'>Who We Are</h2>

        <p class='fs-16 lh-24 mb-0'>
          Designer Journeys is travel redesigned. <br> <br>
          We connect you to a global network of trusted Local Designers who design, build and deliver extraordinary travel experiences, every time. Local insight, unique destination knowledge and travel planning expertise enables you to fully immerse yourself in the places you visit, all whilst being fully supported by a dedicated team, every step of the way! <br><br>
          With Designer Journeys, you'll open your world to travel experiences that you won't find anywhere else.
        </p>
      </div>
    </div>
  </div>
</template>
